/* eslint-disable no-new-func */
/* eslint-disable @typescript-eslint/ban-types */
import cloneDeep from 'lodash-es/cloneDeep';
/**
 * 判断输入的对象是不是一个 `{ $expr: string }` 对象。如果是的话，可以用于 processMaybeExpr 使用哦
 */
export function isExprObject(o) {
    return typeof o === 'object' && o && '$expr' in o && Object.keys(o).length === 1 && typeof o.$expr === 'string';
}
/**
 * 如果传入的对象是个 `{ $expr: "表达式" }` 就做执行并返回结果，否则返回传入的对象的拷贝
 *
 * @param ctxs 可为表达式注入其他的上下文对象，以便表达式引用上下文里面的属性。
 * 越后面的优先级越高（也就是说，出现重名的上下文变量，优先取后面 ctx）
 */
export function processMaybeExpr(data, ...ctxs) {
    if (data === undefined)
        return undefined;
    if (isExprObject(data)) {
        return evalExpr(data.$expr, ...ctxs);
    }
    return cloneDeep(data);
}
export function evalExpr(expr, ...ctx) {
    const ctx2 = ctx.filter(x => typeof x === 'object' && x !== null);
    const ctxNames = ctx2.map((_, i) => `__$ctx${i}`);
    let fn;
    try {
        fn = new Function(...ctxNames, `${ctxNames.map(name => `with(${name})`).join(' ')} return (\n${expr}\n)`);
    }
    catch (_a) {
        fn = new Function(...ctxNames, `${ctxNames.map(name => `with(${name})`).join(' ')} {\n${expr}\n}`);
    }
    return fn(...ctx2);
}
export function tryEvalExpr(expr, defaultValue, ...ctx) {
    try {
        return evalExpr(expr, ...ctx);
    }
    catch (err) {
        return defaultValue;
    }
}
